/**
 * Note: Prod/Dev Authentication is configured in Firebase.js
 *
 * PROD- https://ziprun-prod.uc.r.appspot.com/api/v1
 * QA1- https://ziprun-qa1.uc.r.appspot.com/api/v1
 * QA2- https://ziprun-qa2.uk.r.appspot.com/api/v1 
 */

// staging = QA1/QA2 sites
const isStagingBuild = typeof process.env.REACT_APP_STAGING_BUILD !== 'undefined' &&
                              process.env.REACT_APP_STAGING_BUILD === 'true';

// API: QA2 is the default api domain for web dev. QA1 is generally used for back end development
const api_domain_qa1 = 'https://ziprun-qa1.uc.r.appspot.com';
const api_domain_qa2 = 'https://ziprun-qa2.uk.r.appspot.com';
let api_domain_qa = api_domain_qa2;
if (process.env.PUBLIC_URL && process.env.PUBLIC_URL.indexOf('-qa1') > -1) {
  api_domain_qa = api_domain_qa1;   
}  

// MAPS: QA2 is the default api domain for web dev. QA1 is generally used for back end development
const google_maps_key_qa1 = 'AIzaSyDOxPRDg4rKJnjJK2IuBeLW90PfJ6CKgpU';
const google_maps_key_qa2 = 'AIzaSyAZlGK5Q01ILCn4E8ypjGbgMT9yN87WaG0';
let google_maps_key_qa = google_maps_key_qa2;
if (process.env.PUBLIC_URL && process.env.PUBLIC_URL.indexOf('-qa1') > -1) {
  google_maps_key_qa = google_maps_key_qa1;   
} 

// TODO: remove AeroPay accounts?
const development = {
  REACT_APP_API_DOMAIN: api_domain_qa,
  GOOGLE_MAPS_KEY: google_maps_key_qa,
  AEROPAY_ENV: 'staging',
  AEROPAY_ENABLED: false,
  AEROPAY_MERCHANT_ID: 1089,
  AEROPAY_LOCATION_ID: 1060,
  IS_DEV: true,
  IS_DISABLED: false,
  IS_PREVIEW_MODE: true,  // BROWSE ONLY, NO ORDERING
  PAUSED_DISPENSARIES: [],  /* disable ordering */
  BULK_DISCOUNT_DISPENSARIES: ['47f0d3e1-ffd7-460f-aee2-d24e23c93238']  /* show bulk discount banner */
}

// ALL: ['8b700d49-f5eb-4d2f-ae04-3cfe8ff2a017','972e8edd-b8d5-464a-a41a-eb1a1541c64b','ba16703e-27a0-470e-8735-9722f85a115a','dec3ffe5-8841-4ef5-a539-907baf7d7090','8c56f6e9-4891-4074-8863-213b8c8c1beb','f1ff97f3-37c6-4235-a924-4bf2336cf080','9789118a-b5be-46ab-b248-9cefe4592b5f','f6e5cada-0c78-4245-9151-7fff9bb9955a','57d0bf3e-7f9c-48f8-8e30-efa6039aef0b']

const production = {
  REACT_APP_API_DOMAIN: 'https://ziprun-prod.uc.r.appspot.com',
  GOOGLE_MAPS_KEY: 'AIzaSyAFzrir5dvNfpY9EOFKUBIcxXpJVly-nVI', /* no localhost support */
  AEROPAY_ENV: 'production',
  AEROPAY_ENABLED: false,
  AEROPAY_MERCHANT_ID: 1089,   //  TODO: get prod values or remove?
  AEROPAY_LOCATION_ID: 1060,   //  TDOD: get prod values 
  IS_DEV: false,
  IS_DISABLED: true,
  IS_PREVIEW_MODE: true,  // BROWSE ONLY, NO ORDERING   
  PAUSED_DISPENSARIES: [],   /* disable ordering */
  BULK_DISCOUNT_DISPENSARIES: ['8b700d49-f5eb-4d2f-ae04-3cfe8ff2a017']  /* show bulk discount banner */
}

const config = process.env.NODE_ENV === 'development' || isStagingBuild ? development : production;

export default config;